/*
 * Created by liyi on 2021-02-01 17:04.
 */
import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Badge, Table, Tag} from 'antd';

export default function SyncContactLeaveTable({users, onSelect}) {
    const columns = [
        {
            title: '姓名',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: '邮箱',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: '状态',
            dataIndex: 'enabled',
            // eslint-disable-next-line react/display-name
            render: (text, record) => {
                const {onjob, enabled} = record;
                return (
                    <div>
                        {onjob ? (
                            <div>
                                <Badge status="success" /> 在职
                            </div>
                        ) : (
                            <div>
                                <Badge status="error" /> 离职
                            </div>
                        )}
                        {enabled ? (
                            <div>
                                <Badge status="success" /> 账号正常
                            </div>
                        ) : (
                            <div>
                                <Badge status="error" /> 账号禁用
                            </div>
                        )}
                    </div>
                );
            },
        },
        {
            title: '企业微信状态',
            dataIndex: 'status',
            render: text => {
                if (text === 1) {
                    return <Tag color="#2db7f5">已激活</Tag>;
                } else if (text === 2) {
                    return <Tag color="red">已禁用</Tag>;
                } else if (text === 4) {
                    return <Tag color="purple">未激活</Tag>;
                } else if (text === 5) {
                    return <Tag color="#f50">退出企业</Tag>;
                }
                return '';
            },
        },
    ];

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);

    function onSelectChange(selectedRowKeys, selectedRows) {
        setSelectedRowKeys(selectedRowKeys);
        onSelect(selectedRows);
    }

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    return (
        <Table
            rowKey="id"
            rowSelection={rowSelection}
            columns={columns}
            dataSource={users}
            pagination={false}
        />
    );
}

SyncContactLeaveTable.propTypes = {
    users: PropTypes.array,
    onSelect: PropTypes.func.isRequired,
};
